import React from 'react';
import LoadingIndicator from '../../components/LoadingIndicator';
import FixedFullscreenDiv from '../FixedFullscreenDiv';
import FullScreenVerticalCenterContent from '../../styledhtml/FullScreenVerticalCenterContent/index';
import Constants from '../../submodules/logictry_config/constants';
export default function LoadingFullscreen() {
  if (Constants.isWidget) return <FullScreenVerticalCenterContent alignTop><LoadingIndicator /></FullScreenVerticalCenterContent>;
  return <FixedFullscreenDiv style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><LoadingIndicator /></FixedFullscreenDiv>;
}
